import {populateTaskMonitor, populateYourUploadHistory, populateInstitutionUploadHistory} from '../api'

export const loadTaskMonitor = ({ state, commit }, taskId) => {
  return populateTaskMonitor(taskId).then((response) => {
    commit('LOAD_TASK_MONITOR', response)
    return response
  })
}

export const loadYourUploadHistory = ({ state, commit }) => {
  return populateYourUploadHistory()
}

export const loadInstitutionUploadHistory = ({ state, commit }) => {
  return populateInstitutionUploadHistory()
}



// WEBPACK FOOTER //
// ./src/app/taskMonitor/vuex/actions.js